module.exports = __webpack_public_path__ + "img/Logo.924383d5.png";